import { Memo } from '@/types';

import { apiClient } from '../http';
import { favoriteService } from './favorites';
import { toMemoMutationInput } from './resourceMutationPayloads';
import { createSanitizedResourceService } from './resources';

export interface PublicMemoMentionSnapshot {
    collaboratorCount?: number;
    createdAt?: Date | string;
    description?: string;
    id: string;
    label: string;
    resourceType: string;
    updatedAt?: Date | string;
    website?: string;
}

const base = createSanitizedResourceService<
    Memo,
    ReturnType<typeof toMemoMutationInput>,
    ReturnType<typeof toMemoMutationInput>
>('/api/memos', toMemoMutationInput, toMemoMutationInput);

export const memoService = {
    ...base,
    getPublicById: (id: string) => apiClient.get<Memo>(`/public/memos/${id}`, { mode: 'unauthorized' }),
    getPublicMention: (memoId: string, resourceType: string, resourceId: string) =>
        apiClient.get<PublicMemoMentionSnapshot>(
            `/public/memos/${memoId}/mentions/${resourceType}/${resourceId}`,
            { mode: 'unauthorized' },
        ),
    setArchived: (id: string, archived: boolean) => base.update(id, { archived }),
    setFavorite: (id: string, favorited: boolean) => favoriteService.set<Memo>('memos', id, favorited),
    setLocked: (id: string, locked: boolean) => base.update(id, { locked }),
};
